/**
 * [Date.js](https://github.com/datejs/Datejs)
 * 主要参考Git上，做定制化，部分需求不常见，则不需要添加该代码
 */

(function() {
  var $D = Date

  var $P = $D.prototype

  var $C = $D.CultureInfo

  /**
     * Resets the time of this Date object to 12:00 AM (00:00), which is the start of the day.
     * @return {Date}    this
     */
  $P.clearTime = function() {
    this.setHours(0)
    this.setMinutes(0)
    this.setSeconds(0)
    this.setMilliseconds(0)
    return this
  }

  /**
     * Gets a date that is set to the current date. The time is set to the start of the day (00:00 or 12:00 AM).
     * @return {Date}    The current date.
    */
  $D.today = function() {
    return new Date().clearTime()
  }

  /**
     * Compares the first date to the second date and returns an number indication of their relative values.
     * @param {Date}     First Date object to compare [Required].
     * @param {Date}     Second Date object to compare to [Required].
     * @return {Number}  -1 = date1 is lessthan date2. 0 = values are equal. 1 = date1 is greaterthan date2.
     */
  $D.compare = function(date1, date2) {
    if (isNaN(date1) || isNaN(date2)) {
      throw new Error(date1 + '-' + date2)
    } else if (date1 instanceof Date && date2 instanceof Date) {
      return (date1 < date2) ? -1 : ((date1 > date2) ? 1 : 0)
    } else {
      throw new TypeError(date1 + '-' + date2)
    }
  }

  // $D.getDayNumberFromWeekName

  // $D.getMonthNumberFromName

  /**
     * Compares the first Date object to the second Date object and returns true if they are equal.
     * @param {Date}     First Date object to compare [Required]
     * @param {Date}     Second Date object to compare to [Required]
     * @return {Boolean} true if dates are equal. false if they are not equal.
     */
  $D.equals = function(date1, date2) {
    return (date1.compareTo(date2) === 0)
  }

  /**
     * 闰年判断 Determines if the current date instance is within a LeapYear.
     * @param {Number}   The year.
     * @return {Boolean} true if date is within a LeapYear, otherwise false.
     */
  $D.isLeapYear = function (year) {
    return ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0)
  }

  /**
     * Gets the number of days in the month, given a year and month value. Automatically corrects for LeapYear.
     * @param {Number}   The year.
     * @param {Number}   The month (0-11).
     * @return {Number}  The number of days in the month.
     */
  $D.getDaysInMonth = function (year, month) {
    return [31, ($D.isLeapYear(year) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month]
  }

  /**
     * Returns a new Date object that is an exact date and time copy of the original instance.
     * @return {Date}    A new Date instance
     */
  $P.clone = function () {
    return new Date(this.getTime())
  }

  /**
     * Compares this instance to a Date object and returns an number indication of their relative values.
     * @param {Date}     Date object to compare [Required]
     * @return {Number}  -1 = this is lessthan date. 0 = values are equal. 1 = this is greaterthan date.
     */
  $P.compareTo = function (date) {
    return Date.compare(this, date)
  }

  /**
     * Compares this instance to another Date object and returns true if they are equal.
     * @param {Date}     Date object to compare. If no date to compare, new Date() [now] is used.
     * @return {Boolean} true if dates are equal. false if they are not equal.
     */
  $P.equals = function (date) {
    return Date.equals(this, date || new Date())
  }

  /// /////////////////////////////////////////////////////////////////////////////////////////
  // 计算两个日期天数差的函数，通用
  /// /////////////////////////////////////////////////////////////////////////////////////////
  $D.diffDays = function(sDate1, sDate2) { // sDate1和sDate2是yyyy-MM-dd格式
    var s1 = new Date(sDate1.replace(/-/g, '/')).formatDate('yyyy-MM-dd')
    var s2 = new Date(sDate2.replace(/-/g, '/')).formatDate('yyyy-MM-dd')
    var aDate, oDate1, oDate2, iDays
    aDate = s1.split('-')
    oDate1 = new Date(aDate[1] + '/' + aDate[2] + '/' + aDate[0]) // 转换为yyyy-MM-dd格式
    aDate = s2.split('-')
    oDate2 = new Date(aDate[1] + '/' + aDate[2] + '/' + aDate[0])
    iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24) // 把相差的毫秒数转换为天数
    return iDays // 返回相差天数
  }

  $D.getFormatDate = function(dateStr) {
    if (!dateStr) return null
    var aDate = dateStr.split('-')
    return new Date(aDate[1] + '/' + aDate[2] + '/' + aDate[0])
  }

  // 得到两个日期区间的日期列表
  $D.getDiffList = function(sDate1, sDate2) {
    var s1 = new Date(sDate1.replace(/-/g, '/')).formatDate('yyyy-MM-dd')
    var s2 = new Date(sDate2.replace(/-/g, '/')).formatDate('yyyy-MM-dd')
    var arr = []
    arr.push(s1)
    for (var i = 1; i <= Date.diffDays(s1, s2); i++) {
      var d = new Date(new Date(s1).setDate(new Date(s1).getDate() + i)).formatDate('yyyy-MM-dd')
      arr.push(d)
      if (d === s2) {
        break
      }
    }
    return arr
  }

  /**
     * Determines if the current Date instance occurs on the same Date as the supplied 'date'.
     * If no 'date' to compare to is provided, the current Date instance is compared to 'today'.
     * @param {date}     Date object to compare. If no date to compare, the current Date ("now") is used.
     * @return {Boolean} true if this Date instance occurs on the same Day as the supplied 'date'.
     */
  $P.isToday = $P.isSameDay = function (date) {
    return this.clone().clearTime().equals((date || new Date()).clone().clearTime())
  }

  /**
      * Adds the specified number of milliseconds to this instance.
      * @param {Number}   The number of milliseconds to add. The number can be positive or negative [Required]
      * @return {Date}    this
      */
  $P.addMilliseconds = function (value) {
    this.setMilliseconds(this.getMilliseconds() + value * 1)
    return this
  }

  /**
      * Adds the specified number of seconds to this instance.
      * @param {Number}   The number of seconds to add. The number can be positive or negative [Required]
      * @return {Date}    this
      */
  $P.addSeconds = function (value) {
    return this.addMilliseconds(value * 1000)
  }

  /**
      * Adds the specified number of seconds to this instance.
      * @param {Number}   The number of seconds to add. The number can be positive or negative [Required]
      * @return {Date}    this
      */
  $P.addMinutes = function (value) {
    return this.addMilliseconds(value * 60000) /* 60*1000 */
  }

  /**
      * Adds the specified number of hours to this instance.
      * @param {Number}   The number of hours to add. The number can be positive or negative [Required]
      * @return {Date}    this
      */
  $P.addHours = function (value) {
    return this.addMilliseconds(value * 3600000) /* 60*60*1000 */
  }

  /**
      * Adds the specified number of days to this instance.
      * @param {Number}   The number of days to add. The number can be positive or negative [Required]
      * @return {Date}    this
      */
  $P.addDays = function (value) {
    this.setDate(this.getDate() + value * 1)
    return this
  }

  /**
      * Adds the specified number of weeks to this instance.
      * @param {Number}   The number of weeks to add. The number can be positive or negative [Required]
      * @return {Date}    this
      */
  $P.addWeeks = function (value) {
    return this.addDays(value * 7)
  }

  /**
      * Adds the specified number of months to this instance.
      * @param {Number}   The number of months to add. The number can be positive or negative [Required]
      * @return {Date}    this
      */
  $P.addMonths = function (value) {
    var n = this.getDate()
    this.setDate(1)
    this.setMonth(this.getMonth() + value * 1)
    this.setDate(Math.min(n, $D.getDaysInMonth(this.getFullYear(), this.getMonth())))
    return this
  }

  /**
      * Adds the specified number of years to this instance.
      * @param {Number}   The number of years to add. The number can be positive or negative [Required]
      * @return {Date}    this
      */
  $P.addYears = function (value) {
    return this.addMonths(value * 12)
  }

  // $P.getWeek

  /**
     * Converts the value of the current Date object to its equivalent string representation.
     * Format Specifiers
    <pre>
    CUSTOM DATE AND TIME FORMAT STRINGS
    Format  Description                                                                  Example
    ------  ---------------------------------------------------------------------------  -----------------------
     s      The seconds of the minute between 0-59.                                      "0" to "59"
     ss     The seconds of the minute with leading zero if required.                     "00" to "59"

     m      The minute of the hour between 0-59.                                         "0"  or "59"
     mm     The minute of the hour with leading zero if required.                        "00" or "59"

     h      The hour of the day between 1-12.                                            "1"  to "12"
     hh     The hour of the day with leading zero if required.                           "01" to "12"

     H      The hour of the day between 0-23.                                            "0"  to "23"
     HH     The hour of the day with leading zero if required.                           "00" to "23"

     d      The day of the month between 1 and 31.                                       "1"  to "31"
     dd     The day of the month with leading zero if required.                          "01" to "31"
     ddd    Abbreviated day name. $C.abbreviatedDayNames.                                "Mon" to "Sun"
     dddd   The full day name. $C.dayNames.                                              "Monday" to "Sunday"

     M      The month of the year between 1-12.                                          "1" to "12"
     MM     The month of the year with leading zero if required.                         "01" to "12"
     MMM    Abbreviated month name. $C.abbreviatedMonthNames.                            "Jan" to "Dec"
     MMMM   The full month name. $C.monthNames.                                          "January" to "December"
     yy     The year as a two-digit number.                                              "99" or "08"
     yyyy   The full four digit year.                                                    "1999" or "2008"

     t      Displays the first character of the A.M./P.M. designator.                    "A" or "P"
            $C.amDesignator or $C.pmDesignator
     tt     Displays the A.M./P.M. designator.                                           "AM" or "PM"
            $C.amDesignator or $C.pmDesignator

     S      The ordinal suffix ("st, "nd", "rd" or "th") of the current day.            "st, "nd", "rd" or "th"
|| *Format* || *Description* || *Example* ||
|| d      || The CultureInfo shortDate Format Pattern                                     || "M/d/yyyy" ||
|| D      || The CultureInfo longDate Format Pattern                                      || "dddd, MMMM dd, yyyy" ||
|| F      || The CultureInfo fullDateTime Format Pattern                                  || "dddd, MMMM dd, yyyy h:mm:ss tt" ||
|| m      || The CultureInfo monthDay Format Pattern                                      || "MMMM dd" ||
|| r      || The CultureInfo rfc1123 Format Pattern                                       || "ddd, dd MMM yyyy HH:mm:ss GMT" ||
|| s      || The CultureInfo sortableDateTime Format Pattern                              || "yyyy-MM-ddTHH:mm:ss" ||
|| t      || The CultureInfo shortTime Format Pattern                                     || "h:mm tt" ||
|| T      || The CultureInfo longTime Format Pattern                                      || "h:mm:ss tt" ||
|| u      || The CultureInfo universalSortableDateTime Format Pattern                     || "yyyy-MM-dd HH:mm:ssZ" ||
|| y      || The CultureInfo yearMonth Format Pattern                                     || "MMMM, yyyy" ||

    STANDARD DATE AND TIME FORMAT STRINGS
    Format  Description                                                                  Example ("en-US")
    ------  ---------------------------------------------------------------------------  -----------------------
     d      The CultureInfo shortDate Format Pattern                                     "M/d/yyyy"
     D      The CultureInfo longDate Format Pattern                                      "dddd, MMMM dd, yyyy"
     F      The CultureInfo fullDateTime Format Pattern                                  "dddd, MMMM dd, yyyy h:mm:ss tt"
     m      The CultureInfo monthDay Format Pattern                                      "MMMM dd"
     r      The CultureInfo rfc1123 Format Pattern                                       "ddd, dd MMM yyyy HH:mm:ss GMT"
     s      The CultureInfo sortableDateTime Format Pattern                              "yyyy-MM-ddTHH:mm:ss"
     t      The CultureInfo shortTime Format Pattern                                     "h:mm tt"
     T      The CultureInfo longTime Format Pattern                                      "h:mm:ss tt"
     u      The CultureInfo universalSortableDateTime Format Pattern                     "yyyy-MM-dd HH:mm:ssZ"
     y      The CultureInfo yearMonth Format Pattern                                     "MMMM, yyyy"
    </pre>
     * @param {String}   A format string consisting of one or more format spcifiers [Optional].
     * @return {String}  A string representation of the current Date object.
     */
  $P._toString = $P.toString
  $P.toString = function (format) {
    // console.log('----format')
    var x = this
    // Standard Date and Time Format Strings. Formats pulled from CultureInfo file and
    // may vary by culture.
    if (format && format.length == 1) {
      var c = $C.formatPatterns
      x.t = x.toString
      switch (format) {
        case 'd':
          return x.t(c.shortDate)
        case 'D':
          return x.t(c.longDate)
        case 'F':
          return x.t(c.fullDateTime)
        case 'm':
          return x.t(c.monthDay)
        case 'r':
          return x.t(c.rfc1123)
        case 's':
          return x.t(c.sortableDateTime)
        case 't':
          return x.t(c.shortTime)
        case 'T':
          return x.t(c.longTime)
        case 'u':
          return x.t(c.universalSortableDateTime)
        case 'y':
          return x.t(c.yearMonth)
      }
    }

    var ord = function (n) {
      switch (n * 1) {
        case 1:
        case 21:
        case 31:
          return 'st'
        case 2:
        case 22:
          return 'nd'
        case 3:
        case 23:
          return 'rd'
        default:
          return 'th'
      }
    }

    return format ? format.replace(/(\\)?(dd?d?d?|MM?M?M?|yy?y?y?|hh?|HH?|mm?|ss?|tt?|S)/g,
      function (m) {
        if (m.charAt(0) === '\\') {
          return m.replace('\\', '')
        }
        x.h = x.getHours
        switch (m) {
          case 'hh':
            return p(x.h() < 13 ? (x.h() === 0 ? 12 : x.h()) : (x.h() - 12))
          case 'h':
            return x.h() < 13 ? (x.h() === 0 ? 12 : x.h()) : (x.h() - 12)
          case 'HH':
            return p(x.h())
          case 'H':
            return x.h()
          case 'mm':
            return p(x.getMinutes())
          case 'm':
            return x.getMinutes()
          case 'ss':
            return p(x.getSeconds())
          case 's':
            return x.getSeconds()
          case 'yyyy':
            return p(x.getFullYear(), 4)
          case 'yy':
            return p(x.getFullYear())
          case 'dddd':
            return $C.dayNames[x.getDay()]
          case 'ddd':
            return $C.abbreviatedDayNames[x.getDay()]
          case 'dd':
            return p(x.getDate())
          case 'd':
            return x.getDate()
          case 'MMMM':
            return $C.monthNames[x.getMonth()]
          case 'MMM':
            return $C.abbreviatedMonthNames[x.getMonth()]
          case 'MM':
            return p((x.getMonth() + 1))
          case 'M':
            return x.getMonth() + 1
          case 't':
            return x.h() < 12 ? $C.amDesignator.substring(0, 1) : $C.pmDesignator.substring(0, 1)
          case 'tt':
            return x.h() < 12 ? $C.amDesignator : $C.pmDesignator
          case 'S':
            return ord(x.getDate())
          default:
            return m
        }
      }
    ) : this._toString()
  }
  $P.formatDate = function (format) {
    // console.log('----format')
    var x = this
    // Standard Date and Time Format Strings. Formats pulled from CultureInfo file and
    // may vary by culture.
    if (format && format.length == 1) {
      var c = $C.formatPatterns
      x.t = x.toString
      switch (format) {
        case 'd':
          return x.t(c.shortDate)
        case 'D':
          return x.t(c.longDate)
        case 'F':
          return x.t(c.fullDateTime)
        case 'm':
          return x.t(c.monthDay)
        case 'r':
          return x.t(c.rfc1123)
        case 's':
          return x.t(c.sortableDateTime)
        case 't':
          return x.t(c.shortTime)
        case 'T':
          return x.t(c.longTime)
        case 'u':
          return x.t(c.universalSortableDateTime)
        case 'y':
          return x.t(c.yearMonth)
      }
    }

    var ord = function (n) {
      switch (n * 1) {
        case 1:
        case 21:
        case 31:
          return 'st'
        case 2:
        case 22:
          return 'nd'
        case 3:
        case 23:
          return 'rd'
        default:
          return 'th'
      }
    }

    return format ? format.replace(/(\\)?(dd?d?d?|MM?M?M?|yy?y?y?|hh?|HH?|mm?|ss?|tt?|S)/g,
      function (m) {
        if (m.charAt(0) === '\\') {
          return m.replace('\\', '')
        }
        x.h = x.getHours
        switch (m) {
          case 'hh':
            return p(x.h() < 13 ? (x.h() === 0 ? 12 : x.h()) : (x.h() - 12))
          case 'h':
            return x.h() < 13 ? (x.h() === 0 ? 12 : x.h()) : (x.h() - 12)
          case 'HH':
            return p(x.h())
          case 'H':
            return x.h()
          case 'mm':
            return p(x.getMinutes())
          case 'm':
            return x.getMinutes()
          case 'ss':
            return p(x.getSeconds())
          case 's':
            return x.getSeconds()
          case 'yyyy':
            return p(x.getFullYear(), 4)
          case 'yy':
            return p(x.getFullYear())
          case 'dddd':
            return $C.dayNames[x.getDay()]
          case 'ddd':
            return $C.abbreviatedDayNames[x.getDay()]
          case 'dd':
            return p(x.getDate())
          case 'd':
            return x.getDate()
          case 'MMMM':
            return $C.monthNames[x.getMonth()]
          case 'MMM':
            return $C.abbreviatedMonthNames[x.getMonth()]
          case 'MM':
            return p((x.getMonth() + 1))
          case 'M':
            return x.getMonth() + 1
          case 't':
            return x.h() < 12 ? $C.amDesignator.substring(0, 1) : $C.pmDesignator.substring(0, 1)
          case 'tt':
            return x.h() < 12 ? $C.amDesignator : $C.pmDesignator
          case 'S':
            return ord(x.getDate())
          default:
            return m
        }
      }
    ) : this.formatDate()
  }

  function p (s, l) {
    if (!l) {
      l = 2
    }
    return ('000' + s).slice(l * -1)
  }
})()
